import { createEnumMap } from 'Commons/helpers/utils/Formatter';
import enums from './enums';

const FIELD_STATE = createEnumMap(enums.fieldState);

export default FIELD_STATE;

export { FIELD_STATE };
